import { Button, Grid } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React from 'react'
import { useSearchParams } from 'react-router-dom';
import { useAppContext } from '../../../libs/app-core/AppContext';
import { Toast } from '../../../libs/app-core/Toast';
import { useGridApiRef } from '../../../libs/data-grid-view/useGridApiRef';
import { linear_h, linear_item, linear_v } from '../../../libs/linear-layout/LinearLayout';
import Title from '../../../libs/rhf-mui/ui/Title';
import { ROUTE_form_def } from '../../Routes';
import { EnableModeOptions, HisRuleOptions, RequiredModeOptions } from '../../dao/SpwkUtilV3';
import { UniInput } from '../../dao/UniInput';
import { UniInputDAO, useUniInputList } from '../../dao/UniInputDAO';
import { useUniOption } from '../../dao/UniOptionDAO';
import { OnApiError } from '../../ErrorManager';

type Props = {}

const FrmUniInputDefinition = (props: Props) => {
  const ctx = useAppContext();

  const [searchParams] = useSearchParams();// UrlQueryParams
  const option_guid = searchParams.get("option") ?? "";
  //---------------------------------------------------------

  const { _UniOption } = useUniOption(option_guid);
  const { _UniInputList, refresh_UniInputList } = useUniInputList(option_guid);
  const uni_form_columns: GridColDef[] = [
    { field: 'serno', headerName: 'serno', width: 85, editable: true },
    { field: "i_his_rule", headerName: "his_rule", width: 90, editable: true, type: "singleSelect", valueOptions: HisRuleOptions, },
    { field: 'i_his_code', headerName: 'i_his_code', width: 240, editable: true },
    { field: 'i_gov_code', headerName: 'i_gov_code', width: 160, editable: true },
    { field: 'input_code', headerName: 'input_code', width: 160, editable: true },
    {
      field: 'input_kind', headerName: 'input_kind', width: 120, editable: true, type: "singleSelect",
      valueOptions: [
        { value: "", label: '(未設定)' },
        { value: "Text", label: 'Text' },
        { value: "Select", label: 'Select' },
        { value: "Int", label: 'Int' },
        { value: "Number", label: 'Number' },
        { value: "DateTime", label: 'DateTime' },
      ]
    },
    { field: 'width', headerName: 'width', width: 160, editable: true },
    { field: 'input_format', headerName: 'input_format', width: 160, editable: true },
    { field: 'input_items', headerName: 'input_item', width: 160, editable: true },
    {
      field: 'input_enabled', headerName: 'input_enabled', width: 160, editable: true, type: "singleSelect",
      valueOptions: EnableModeOptions,
    },
    {
      field: 'input_required', headerName: 'input_required', width: 160, editable: true, type: "singleSelect",
      valueOptions: RequiredModeOptions,
    },

    { field: 'digit', headerName: 'digit', width: 160, editable: true },
    { field: 'min_value', headerName: 'min_value', width: 160, editable: true },
    { field: 'max_value', headerName: 'max_value', width: 160, editable: true },
    { field: 'rows', headerName: 'rows', width: 160, editable: true, },
    { field: 'input_label', headerName: 'input_label', width: 160, editable: true },
    { field: 'place_holder', headerName: 'place_holder', width: 160, editable: true },
  ];

  const grid_api = useGridApiRef(uni_form_columns);

  async function btn_新增_Click() {
    try {
      if (_UniOption == null || _UniOption.guid == null) {
        Toast.ShowWarning(ctx, "未載入Option");
        return;
      }

      await UniInputDAO.Insert_新增空白Input(_UniOption.guid);

      await refresh_UniInputList();

      Toast.Show(ctx, "新增Input");

    } catch (ex: any) {
      OnApiError(ctx, ex);
    }
  }

  function btn_刪除_Click() {
    Toast.Show(ctx, "還沒做");
  }

  function render_ActionBar(): React.ReactNode {
    return (<Grid  {...linear_h} alignItems='center' p={1}>
      <Button onClick={() => {
        ctx.Navigate(ROUTE_form_def.url + "?form=" + _UniOption?.form_guid + "&focus_question=" + _UniOption?.question_guid);
      }}>{"<< 返回上一頁"}</Button>

      <Grid {...linear_item} flex={1}>
        {/* blank full width */}
      </Grid>
      <Grid {...linear_item}>
        <Button color='inherit' onClick={btn_新增_Click}>新增Input定義</Button>
      </Grid>

      <Grid {...linear_item}>
        <Button color='error' onClick={btn_刪除_Click}>{"刪除"}</Button>
      </Grid>


      <Grid {...linear_item}>
        <Title>...</Title>
      </Grid>
    </Grid>);
  }

  function render_DataGrid(): React.ReactNode {
    return (
      <DataGrid style={{ width: '100%', backgroundColor: 'white', padding: '12px' }}
        getRowId={(data) => { return data.guid }}
        rows={_UniInputList}
        columns={grid_api.columns}

        density={'compact'} pageSize={100} rowsPerPageOptions={[100]} hideFooterSelectedRowCount
        hideFooter

        onCellEditCommit={async ({ id, field, value }) => {

          try {
            try {
              const data = new UniInput();
              data.guid = id as string;

              await UniInputDAO.UpdateOneField(data, field, value);

              refresh_UniInputList();

              Toast.ShowScuccess(ctx, "儲存成功");
            } catch {
              Toast.ShowDanger(ctx, "儲存失敗!!!");
            }

          } catch {
            Toast.ShowDanger(ctx, "儲存失敗!!!");
          }

        }}
      />
    );
  }

  return (
    <>
      <Grid {...linear_v} >
        <Grid {...linear_item}  >
          {render_ActionBar()}
        </Grid>
        <Grid {...linear_item} flex={1} >
          {render_DataGrid()}
        </Grid>
      </Grid>
    </>
  )
}

export default FrmUniInputDefinition